import React, {Component} from 'react';
import './App.css';
//import TestUnit from './Test/test'
import MainBodyTest from './MainBody/MainBodyTest'
import SignIn from './MainBody/SignIn'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';



class App extends Component{
  constructor(props) {
    super(props)
    this.state = {
        signIn:false,
        userID:null,
        userName:null,
        open:true,
        eventListState:null
    }
  }
  
  getValidation=(msg)=>{
    this.setState({
      signIn:true,
      userID:msg.userID,
      userName:msg.userName,
      userIP:msg.userIP
    })
  }

  



  render(){
    console.log("App render...")

    return (
      <BrowserRouter>
        <Switch>      
          <Route exact path="/login" render={(props) => <SignIn getAccount={this.getAccount} getPassword={this.getPassword} getValidation={this.getValidation} {...props} /> }/> 
          {this.state.signIn? <Route exact path="/dashboard" render={(props) => <MainBodyTest userID={this.state.userID} userName={this.state.userName} userIP={this.state.userIP} {...props}/> }/>:<Redirect to="/login"/> }
        </Switch>
      </BrowserRouter>
     // <div>
          //<MainBodyTest/>
      //</div>
    )
  }
}

export default App;
